<shaka-player *ngIf="dashUrl || fpsHlsUrl" [url]="dashUrl" [previewsUrl]="previewsUrl" [widevineUrl]="widevineUrl"
	[fairplayUrl]="fairplayUrl" [fpsHlsUrl]="fpsHlsUrl" [poster]="poster" [videoId]="dashVideoId" [uid]="uid"
	[autoplay]="true" [startTimeMs]="startTimeMs" [textTracks]="textTracks" [title]="title" [mediaId]="mediaId">
</shaka-player>
<ng-container *ngIf="deviceLimitError">
    <div class="device-limit-error" dpadZone>
        <div class="error-message">
            This device is not activated or you have reached your device limit for streaming video.<br>
            Go to the website below to manage your devices.
        </div>
        <h4 class="url">{{ config.remoteConfig.base_url }}/account/device-management</h4>
        <button class="btn btn-secondary font-weight-bold dpad-start dpad-zone-start" dpadSelectable (click)="returnToPreviousPage()" (keyup.enter)="returnToPreviousPage()">
            Go Back
        </button>
    </div>
</ng-container>

<!--<div class="container">-->
<!--	<videojs *ngIf="(safari === true && hlsUrl) || (hlsUrl && !dashUrl)" [url]="hlsUrl" [poster]="poster"-->
<!--		[videoId]="hlsVideoId" [audioOnlyOption]="audioOnlyOption" [type]="type" [autoplay]="true"-->
<!--		[startTimeMs]="startTimeMs"></videojs>-->
<!--</div>-->
